import { createAsyncThunk } from '@reduxjs/toolkit';
import LandpageServices from './landingpage_service';

export const getPublicProducts = createAsyncThunk(
  'landpage/get_public_products',
  async (payload, thunkAPI) => {
    try {
      const response = await LandpageServices.getPublicProducts(payload);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getPublicCategories = createAsyncThunk(
  'landpage/get_public_categories',
  async (payload, thunkAPI) => {
    try {
      const response = await LandpageServices.getPublicCategories(payload);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const GetNewProduct = createAsyncThunk(
  'landpage/get_new_product',
  async (payload, thunkAPI) => {
    try {
      const response = await LandpageServices.getNewProduct(payload);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
